import React from 'react';
import './SpeedoVerifiedBadge.css';

/**
 * SpeedoVerifiedBadge
 * Authentic Blue Scalloped Rosette Tick for Monetized Channels & Creators.
 * Matches the official Speedoearn verified partner badge.
 */
export default function SpeedoVerifiedBadge({
  size = 15,
  className = '',
  title = 'Verified • Speedoearn Monetized Partner',
  style = {},
  showTooltip = true,
}) {
  return (
    <span
      className={`speedo-verified-badge-wrapper ${className}`}
      title={showTooltip ? title : undefined}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        lineHeight: 1,
        flexShrink: 0,
        cursor: 'pointer',
        ...style,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="speedo-verified-svg"
      >
        {/* Scalloped Electric Blue Rosette Background */}
        <path
          d="M22.25 12c0-1.43-.88-2.67-2.19-3.21.34-1.39-.07-2.9-1.09-3.92s-2.53-1.43-3.92-1.09C14.5 2.47 13.26 1.59 11.83 1.59s-2.67.88-3.21 2.19c-1.39-.34-2.9.07-3.92 1.09s-1.43 2.53-1.09 3.92C2.47 9.33 1.59 10.57 1.59 12s.88 2.67 2.19 3.21c-.34 1.39.07 2.9 1.09 3.92s2.53 1.43 3.92 1.09c.54 1.31 1.78 2.19 3.21 2.19s2.67-.88 3.21-2.19c1.39.34 2.9-.07 3.92-1.09s1.43-2.53 1.09-3.92c1.31-.54 2.19-1.78 2.19-3.21z"
          fill="#1D9BF0"
        />
        {/* Solid Pure White Centered Checkmark */}
        <path
          d="M9.9 16.5a1 1 0 0 1-.71-.29l-3.2-3.2a1.002 1.002 0 1 1 1.42-1.42l2.49 2.49 6.09-6.09a1.002 1.002 0 1 1 1.42 1.42l-6.8 6.8a1 1 0 0 1-.71.29z"
          fill="#FFFFFF"
        />
      </svg>
    </span>
  );
}
